import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './vuex/store.js';
import * as publicMethod from './utils';
import { unionFlag, priceFormat } from './utils';
import Union from './utils/union/setUnion';
import apis from './apis';
// import VueLazyload from 'vue-lazyload';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/index.less';
import API_ENV from './utils/API_ENV';
import injectionWindow from './utils/lang/index';

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// import AmapVue from '@amap/amap-vue';

// AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
// AmapVue.config.key = '8b430b10314aee6969f5154724c52697';
// AmapVue.config.plugins = [
//   'AMap.ToolBar',
//   'AMap.MoveAnimation',
//   // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
// ];
// 

import {
  Row,
  Col,
  Cascader,
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  DatePicker,
  Select,
  Option,
  Message,
  Image,
  Breadcrumb,
  BreadcrumbItem,
  Pagination,
  Loading,
  Popover,
  tabs,
  Tooltip,
  TabPane,
  Switch,
} from 'element-ui';
import Cookies from "js-cookie";

Vue.use(Row);
Vue.use(Col);
Vue.use(Cascader);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Image);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Input);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(tabs);
Vue.use(TabPane);
Vue.use(Switch);
Vue.use(Tooltip);
Vue.use(Loading);
// Vue.use(AmapVue);

// Vue.use(VueLazyload);
Vue.prototype.union_isBilingual = false;
injectionWindow();
Vue.prototype.TLang = window.TLang;
Vue.prototype.ReplaceText = window.ReplaceText;
Vue.prototype.CheckCN = window.CheckCN;

// 工会
const union = new Union();
const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
if (unionF && unionF !== 'null') {
  sessionStorage.setItem('dffl_union', unionF);
  union.setUnionScale();
  union.findByUnion();
}

Cookies.remove('address', { domain: '.dongfangfuli.com' });
Vue.use(Loading.directive);
Vue.prototype.$message = Message;
Vue.prototype.publicMethod = publicMethod;
Vue.prototype.apis = apis;
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;
Vue.prototype.$origin = window.location.origin;

function isFeishu() { 
  var result = navigator.userAgent.toLowerCase().indexOf("lark/");
  return result >= 0 ? true : false;
}

function isDingDing() {
  var result = navigator.userAgent.toLowerCase().indexOf('dingtalk')
  return result >= 0 ? true : false
}
function isFeishuOrDingding() {
  return isFeishu() || isDingDing()
}
Vue.prototype.isFeishuOrDingding = isFeishuOrDingding();

// 格式化价格样式 <FormatPrice :price="100" size="m"/>
Vue.component('FormatPrice', {
  props: {
    price: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      default: 'm',
    },
  },
  render: function (createElement) {
    if ((!this.price && this.price !== 0) || this.price < 0) return;
    let before, after, floatPrice, beforeStyle, afterStyle;
    floatPrice = this.price.toFixed(2);
    let stringValue = new String(floatPrice);
    before = stringValue.split('.')[0];
    after = stringValue.split('.')[1];
    switch (this.size) {
      case 's':
        beforeStyle = {
          fontSize: '16px',
        };
        afterStyle = {
          fontSize: '12px',
        };
        break;
      case 'm':
        beforeStyle = {
          fontSize: '20px',
        };
        afterStyle = {
          fontSize: '14px',
        };
        break;
      case 'l':
        beforeStyle = {
          fontSize: '24px',
        };
        afterStyle = {
          fontSize: '18px',
        };
        break;
    }
    return createElement(
      'span', // 标签名称
      {
        style: {
          color: '#F44545',
          fontFamily: 'Tahoma',
        },
      },
      [
        '',
        createElement('span', {
          // 小数点前面
          attrs: { class: 'before' },
          domProps: {
            innerHTML: before + '.',
          },
          style: beforeStyle,
        }),
        '',
        // 小数点后面
        createElement('span', {
          attrs: { class: 'after' },
          domProps: {
            innerHTML: after,
          },
          style: afterStyle,
        })
      ],
    );
  },
});

Vue.directive("price", {
  bind: function (el, binding) {
    const val = priceFormat(binding.value);
    if (!val) return "";
    const keys = Object.keys(binding.modifiers);
    console.log(keys)
    let s = [];
    if (keys.length) {
      const k = keys[0];
      switch (k) {
        case "lg":
          // lg
          s = [24, 16];
          break;
        case "sm":
          // sm
          s = [16, 12];
          break;
        default:
          // md
          s = [20, 14];
          break;
      }
    } else {
      s = [20, 14];
    }

    const html = val.replace(
      /(\d+)(\.)(\d+)/,
      ($0, $1, $2, $3) =>
        `<span style="font-size: ${s[0]}px">${$1}</span>${$2}<span style="font-size: ${s[1]}px">${$3}</span>`
    );

    el.innerHTML = html;
  }
});
// 埋点
let pageId;
router.beforeEach((to, from, next) => {
  next();
  pageId = to.meta.pageId || to.meta.title;
  document.title = to.meta.title;
});

// router里操作都是异步的，只能用setTimeout让它加入异步队列执行
// setTimeout(() => {
//   const address = decodeURIComponent(publicMethod.getCookie("address"));
//   let cityId;

//   cityId = address ? JSON.parse(address).cityId : "";
// });

// 变态的诺和诺德工会英文字体用Verdana
if (publicMethod.unionFlag() === "aon") {
  document.body.style.fontFamily =
    "Verdana, PingFang SC, Hiragino Sans GB, Microsoft YaHei";
}

// sentry
if (API_ENV == 'production') {
  Sentry.init({
    dsn: "https://ba27ae8bdd734705b3b0312cf90e872e@sentry.dongfangfuli.com/24",
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

import modules from './modules'
Vue.use(modules)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
